// :)
/**
 * GitHub Actions workflow YAML template for Synkro PR scanning.
 *
 * Customer commits this to .github/workflows/synkro.yml. Triggers on
 * pull_request open/synchronize/reopened. Runs `synkro scan-pr` which
 * spawns claude --print with their CLAUDE_CODE_OAUTH_TOKEN per file.
 *
 * Both CLIs install via npm (npm registry attestations + signed packages
 * are verified by npm itself). No curl-pipe-to-bash; we publish to npm
 * specifically so CI can install us through a trusted package manager.
 */

export const SYNKRO_WORKFLOW_YAML = `name: Synkro Security Review
on:
  pull_request:
    types: [opened, synchronize, reopened]
  workflow_dispatch:
    inputs:
      pr_number:
        description: PR number to scan
        required: true
      sha:
        description: Commit SHA to scan
        required: true

jobs:
  scan:
    runs-on: ubuntu-latest
    permissions:
      contents: write
      pull-requests: write
      checks: write
    steps:
      - uses: actions/checkout@v4
        with:
          fetch-depth: 0
          ref: \${{ inputs.sha || github.event.pull_request.head.sha }}

      - name: Cache npm globals
        id: cache-npm-global
        uses: actions/cache@v4
        with:
          path: ~/.npm-global
          key: synkro-cli-\${{ runner.os }}-v1

      - name: Install Synkro CLI + Claude Code CLI
        run: |
          npm config set prefix ~/.npm-global
          npm install -g @synkro-sh/cli @anthropic-ai/claude-code
          echo "$HOME/.npm-global/bin" >> $GITHUB_PATH

      - name: Run Synkro PR scan
        run: synkro-cli scan-pr
        env:
          CLAUDE_CODE_OAUTH_TOKEN: \${{ secrets.CLAUDE_CODE_OAUTH_TOKEN }}
          SYNKRO_API_KEY: \${{ secrets.SYNKRO_API_KEY }}
          GH_TOKEN: \${{ secrets.GITHUB_TOKEN }}
          SYNKRO_PR_NUMBER: \${{ inputs.pr_number || github.event.pull_request.number }}
          SYNKRO_REPO: \${{ github.repository }}
          SYNKRO_SHA: \${{ inputs.sha || github.event.pull_request.head.sha }}
          SYNKRO_GATEWAY_URL: \${{ vars.SYNKRO_GATEWAY_URL || 'https://api.synkro.sh' }}
`;

export const WORKFLOW_FILENAME = 'synkro.yml';
export const WORKFLOW_PATH = '.github/workflows/synkro.yml';
